import { render, staticRenderFns } from "./WorkspaceResultMaterials.vue?vue&type=template&id=58041cf4&scoped=true&"
import script from "./WorkspaceResultMaterials.vue?vue&type=script&lang=js&"
export * from "./WorkspaceResultMaterials.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceResultMaterials.vue?vue&type=style&index=0&id=58041cf4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58041cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58041cf4')) {
      api.createRecord('58041cf4', component.options)
    } else {
      api.reload('58041cf4', component.options)
    }
    module.hot.accept("./WorkspaceResultMaterials.vue?vue&type=template&id=58041cf4&scoped=true&", function () {
      api.rerender('58041cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/WorkspaceResultMaterials.vue"
export default component.exports